import {
  HiveCodeToolbarWidget,
  CodeBlockSpec,
} from '@blocksuite/hive/blocks/code';
import { LifeCycleWatcher } from '@blocksuite/hive/std';
import type { ExtensionType } from '@blocksuite/hive/store';

import { setupCodeToolbarAIEntry } from '../entries/code-toolbar/setup-code-toolbar';

class AICodeBlockWatcher extends LifeCycleWatcher {
  static override key = 'ai-code-block-watcher';

  override mounted() {
    super.mounted();
    const { view } = this.std;
    view.viewUpdated.subscribe(payload => {
      if (payload.type !== 'widget' || payload.method !== 'add') {
        return;
      }
      const component = payload.view;
      if (component instanceof HiveCodeToolbarWidget) {
        setupCodeToolbarAIEntry(component);
      }
    });
  }
}

export const AICodeBlockSpec: ExtensionType[] = [
  ...CodeBlockSpec,
  AICodeBlockWatcher,
];
